import { api } from '@/apis';
import { getNewIdentifier, log } from '@/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endOfDay, isValid } from 'date-fns';

export function useUpsertObjective() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ _id, endTime, ...values }) => {
      const json = {
        endTime: isValid(endTime) ? endOfDay(endTime) : endTime,
        ...values,
      };

      if (_id) {
        log('Update', 'Objective', json);

        return api
          .patch(`objectives/${json.identifier}`, {
            headers: { 'content-type': 'application/merge-patch+json' },
            json,
          })
          .json();
      } else {
        const identifier = await getNewIdentifier('OBJECTIVE_');

        log('Create', 'Objective', { identifier, ...json });

        return api.post('objectives', { json: { identifier, ...json } }).json();
      }
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['objectives'] }),
  });
}
